const getWLDomain = (rootState) => rootState.config.service['yola-template-gallery'].wl_domain;

export default getWLDomain;
